import { getCompanyHubEditorRoute } from '@confluence/ssr-app/entry-points/routes';

import { HubEditorRoute } from './HubEditorRoute';

export const CompanyHubEditorRoute = getCompanyHubEditorRoute(HubEditorRoute);
